import configData from "config.json"
import { sendHttpRequest } from "services/ServiceRequest"
import { DatosRecalculo } from "./typesAprobarSolicitudHE"



const API_DATA_RECALCULO = `${configData.SERVER_URL}AprobacionSolicitudesTH/DataRecalculoHE`
const API_RECALCULAR_HE = `${configData.SERVER_URL}AprobacionSolicitudesTH/RecalcularHE`


export async function GetDataRecalculoSolicitud(identificacion:string,idsolicitud:number){

    const api = `${API_DATA_RECALCULO}`
    
    const queryParams = {
        identificacion,
        idsolicitud
    }

    const respuesta = await sendHttpRequest<DatosRecalculo>({
            apiURL:api,
            method : "GET",
            data:queryParams
    })

    return respuesta;
}


export async function RecalcularSolicitudHE(identificacion:string,idsolicitud:number){

    const api = `${API_RECALCULAR_HE}`
    
    const requestbody = {
        identificacion,
        idsolicitud 
    }

    const respuesta = await sendHttpRequest<DatosRecalculo>({
            apiURL:api,
            method : "PUT",
            data:requestbody
    })

    return respuesta;
}